module.exports = __webpack_public_path__ + "img/download-3-panel-4-INT.838422a7.png";